import { render } from "./PostView.vue?vue&type=template&id=3e47391a&scoped=true"
import script from "./PostView.vue?vue&type=script&lang=js"
export * from "./PostView.vue?vue&type=script&lang=js"

import "@/assets/widget.css?vue&type=style&index=0&id=3e47391a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e47391a"]])

export default __exports__